import { SvgIcon } from '@material-ui/core'
import React from 'react'

const RatesIcon = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        d="M15.5 6C15.5 5.72386 15.7239 5.5 16 5.5L20 5.5C20.2761 5.5 20.5 5.72386 20.5 6C20.5 6.27614 20.2761 6.5 20 6.5L16 6.5C15.7239 6.5 15.5 6.27614 15.5 6Z"
      />
      <path
        fillRule="evenodd"
        d="M11.5 10C11.5 9.72386 11.7239 9.5 12 9.5L16 9.5C16.2761 9.5 16.5 9.72386 16.5 10C16.5 10.2761 16.2761 10.5 16 10.5L12 10.5C11.7239 10.5 11.5 10.2761 11.5 10Z"
      />
      <path
        fillRule="evenodd"
        d="M7.5 14C7.5 13.7239 7.72386 13.5 8 13.5L12 13.5C12.2761 13.5 12.5 13.7239 12.5 14C12.5 14.2761 12.2761 14.5 12 14.5L8 14.5C7.72386 14.5 7.5 14.2761 7.5 14Z"
      />
      <path
        fillRule="evenodd"
        d="M3.5 18C3.5 17.7239 3.72386 17.5 4 17.5L8 17.5C8.27614 17.5 8.5 17.7239 8.5 18C8.5 18.2761 8.27614 18.5 8 18.5L4 18.5C3.72386 18.5 3.5 18.2761 3.5 18Z"
      />
    </SvgIcon>
  )
}

export default RatesIcon
